import React from 'react';
import { object, string } from 'prop-types';
import T from 'i18n-react';
import { isPushpinVisible } from '../../../../../../../utils/issues-helpers';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { Tooltip, SvgIcon } from '@adsk/bim360-matrix-react-components';

const PushpinVisibilityIcon = ({ issue, container, hiddenIcon, visibleIcon }) => {

  const { targetUrn } = issue;
  if (!targetUrn) {
    return null;
  }

  let visibilityIcon;
  let iconTooltipText;
  if (isPushpinVisible(issue)) {
    visibilityIcon = visibleIcon;
    iconTooltipText = T.translate('preview.pushpinVisibilityIconTooltip.visible');
  } else {
    visibilityIcon = hiddenIcon;
    iconTooltipText = T.translate('preview.pushpinVisibilityIconTooltip.hidden');
  }

  return (
    <Tooltip content={iconTooltipText} theme={Tooltip.Themes.DARK} container={container} tooltipClassName="LinkedDocumentInlineEdit__tooltip">
      <SvgIcon className="LinkedDocumentInlineEdit__visibility-icon" width="20px" height="20px">
        {visibilityIcon}
      </SvgIcon>
    </Tooltip>
  );
};

PushpinVisibilityIcon.propTypes = {
  issue: issueAttributesType.isRequired,
  container: object.isRequired,
  hiddenIcon: string.isRequired,
  visibleIcon: string.isRequired,
};

export default PushpinVisibilityIcon;
